import {
    ACCOUNT,
    CONTENT_ALBUM_ANALYTICS,
    CONTENT_ALBUM_POSTS,
    DASHBOARD,
    DATA_ACCESS,
    GROUPS,
    HOME,
    ICO_ACADEMY,
    INTEGRATIONS,
    MEDIA,
    NOTIFICATIONS,
    PLATFORM_OPTIONS,
    REPORTS,
    SCHEDULER_COLLABORATION_NOTIFICATIONS,
    SCHEDULER_COLLABORATION_SETTINGS,
    SECURITY,
    SOCIAL_PROFILES,
    SUBSCRIPTION_INVOICES,
    THEMES,
    USERS_ROLES
} from '@/lib/routes/privateRoutes';

export const layoutHeaderDisabled = [
    HOME,
    NOTIFICATIONS,
    GROUPS,
    SOCIAL_PROFILES,
    REPORTS,
    // Dashboard
    DASHBOARD,
    // PUBLISHING
    SCHEDULER_COLLABORATION_SETTINGS,
    SCHEDULER_COLLABORATION_NOTIFICATIONS,
    // SETTINGS
    PLATFORM_OPTIONS,
    USERS_ROLES,
    ACCOUNT,
    THEMES,
    SECURITY,
    DATA_ACCESS,
    INTEGRATIONS,
    SUBSCRIPTION_INVOICES,
    CONTENT_ALBUM_POSTS,
    CONTENT_ALBUM_ANALYTICS,
    // MEDIA
    MEDIA,
    // ICO ACADEMY
    ICO_ACADEMY
];
